import { TYPE_OF_PURCHASE } from '../../constants/DetailedBookingConstants';
import {
    DetailedBookingSOVData, SOVContextualNodeData
} from '../../interface/DetailedBookingInterface';

interface RecalculateValueBlockedByLineItemProps {
    nodes: SOVContextualNodeData[],
    typeOfPurchase: string,
    isContextualSelected: boolean,
    setFormData: React.Dispatch<React.SetStateAction<DetailedBookingSOVData>>
}

export const reCalculateValueBlockedByLineItem = ({
    nodes,
    typeOfPurchase,
    isContextualSelected,
    setFormData
}: RecalculateValueBlockedByLineItemProps
) => {
    if (
        typeOfPurchase === TYPE_OF_PURCHASE.GP_SOV &&
        isContextualSelected
    ) {
        const totalValueBlocked = nodes.reduce(
            (sum, node) => sum + (node.valueBooked || 0),
            0
        );

        setFormData((prev) => ({
            ...prev,
            valueBlockedByLineItem: totalValueBlocked,
        }));
    }
};